import React, { useRef, useEffect } from 'react';

/**
 * ChatInput Component
 * 
 * A rich input area with:
 * - Auto-resizing textarea
 * - Model/Agent selector
 * - Attachment button (mock)
 * - Send button with loading state
 */
const ChatInput = ({
    value,
    onChange,
    onSend,
    isConnected,
    isLoading,
    selectedAgent,
    availableAgents = [],
    onSelectAgent
}) => {
    const textareaRef = useRef(null);

    // Auto-resize textarea
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 200) + 'px';
        }
    }, [value]);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (value.trim() && isConnected && !isLoading) {
                onSend(e);
            }
        }
    };

    return (
        <div className="p-4 bg-base-100/80 backdrop-blur-md border-t border-base-200 sticky bottom-0 z-10 w-full max-w-5xl mx-auto">
            <div className="relative bg-base-200/50 rounded-3xl border border-base-300 shadow-sm transition-all duration-200 focus-within:ring-2 focus-within:ring-primary/20 focus-within:border-primary/50">

                <textarea
                    ref={textareaRef}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder={isConnected ? "Describe your trading strategy... (Shift+Enter for new line)" : "Connect to start..."}
                    disabled={!isConnected || isLoading}
                    className="textarea textarea-ghost w-full bg-transparent border-0 focus:bg-transparent focus:border-0 focus:ring-0 text-base min-h-[56px] py-4 px-4 pr-32 resize-none leading-normal font-sans"
                    rows={1}
                />

                <div className="absolute bottom-2 right-2 flex items-center gap-2">

                    {/* Send Button */}
                    <button
                        onClick={onSend}
                        disabled={!isConnected || isLoading || !value.trim()}
                        className={`btn btn-circle btn-sm shadow-md transition-all duration-200 ${value.trim() ? 'btn-primary scale-100' : 'btn-ghost bg-base-300 text-base-content/30 scale-90'
                            }`}
                    >
                        {isLoading ? (
                            <span className="loading loading-spinner loading-xs"></span>
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                                <path d="M3.105 2.289a.75.75 0 00-.826.95l1.414 4.925A.75.75 0 003.779 8.16l1.414 4.925a.75.75 0 00.98.537l9.887-3.296a.75.75 0 000-1.326L6.173 1.751a.75.75 0 00-1.068.538z" />
                            </svg>
                        )}
                    </button>
                </div>
            </div>

            <div className="flex justify-center mt-2">
                <p className="text-xs text-base-content/40 text-center">
                    AI can make mistakes. Please review generated strategies.
                </p>
            </div>
        </div>
    );
};

export default ChatInput;
